var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyllabus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3152_136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3152_136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 0H0V128H128V0Z",
    fill: "url(#pattern0_3152_136)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3152_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.398 0H6.39844V130.37H134.398V0Z",
    fill: "#172B4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3152_136",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3152_136",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3152_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3152_136",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyllabus);
export default __webpack_public_path__ + "static/media/syllabus.bbb71def99604cab6c62331a15edc073.svg";
export { ForwardRef as ReactComponent };